import {ActionTree} from "vuex";
import {ProfilesState} from "@share/profile/store/ProfilesState";

export const actions: ActionTree<ProfilesState, any> = {
    addUser({commit}, user) {
        commit('addUser', user);
    }
}